import {Component, Prop, Vue} from "vue-property-decorator";
import {DataTable} from "~/components/data-table";
import {formatDate} from "~/lib/helpers/formatters";
import type {PartnerClientDto} from "~/lib/models/app-settings";

@Component
class ClientsTable extends Vue {

  @Prop({type:Array, required:true}) clients: PartnerClientDto[];

  get headers(){
    return [
      {
        key: 'active',
        value: (client) => client.active ?
          <span class="active">Actif</span> :
          <span class="inactive">Inactif</span>,
        label: "Statut",
        type: 'boolean'
      },
      {
        key: 'name',
        value: (client) => client.name,
        label: "Nom société",
      },
      {
        key: 'siret',
        value: (client) => client.siret || "-",
        label: "Code société",
        type: 'object'
      },
      {
        key: 'createdat',
        value: (client) => client.createdat ? formatDate(client.createdat, "dd\/MM\/yyyy HH:mm") : "-",
        label: "Date création",
        type: "object",
      },
    ];
  }


  render() {
    return  <DataTable
      headers={this.headers}
      tableData={this.clients}
      onClickRow={(client) => this.$router.push({ name: 'home', params: { clientUuid: client.uuid }})}
    />
  }
}

export { ClientsTable }

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-1f6da77c/clients-table.tsx" });